// extracted by mini-css-extract-plugin
module.exports = {"header":"_1hwhyXUO1cuPg22epR-KfL","title":"xYnpOkN25BdV2vzQxQ9DN","subTitle":"_2HanQUfuawPl7Ik5qt8Gqz"};